import React, { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { ApiBaseResponse, ResponseCode } from '../../Model/Response/Common/ApiBaseResponse';
import TextBox, { InputType, TextBoxHandle } from '../Components/CoreComponents/textbox';
import TextArea from '../Components/CoreComponents/textarea';
import ComboBox, { ComboBoxMode } from '../Components/CoreComponents/combobox';
import LoadingButton from '../Components/CoreComponents/button';
import { DisplayType, StatusEnum, useShowStatusMessage } from '../Components/CoreComponents/StatusMessage';
import { CityDetail, GetAllCitiesByCountryResponse } from '../../Model/Response/MusteriKurumTanim/GetAllCitiesByCountryResponse';
import { GetClientsStructureByCityIdResponse, ServiceStructureDetailList } from '../../Model/Response/MusteriKurumTanim/GetClientsStructureByCityIdResponse';
import { GetClientsStructureByCityId, GetClientsTreeView } from '../../Controller/Api/MusteriKurumTanimController';
import { GetClientsTreeViewResponse, TreeViewList } from '../../Model/Response/ClientAgent/GetClientsTreeViewResponse';
import { GlobalOperations } from '../../Controller/Common/GlobalOperations';
import citiesData from '../../json/lang_tr-TR.json';
import { SessionManagement, useChat } from './ChatContext';  // ChatContext'ten currentSession'ı almak için
import { MesajiGonderenTarafEnum } from '../../Model/Response/ClientAgent/GetChatSessionDetailResponse';
import { EndSessionByAgentRequest } from '../../Model/Request/SignalR/EndSessionByAgentRequest';
import { FaCheckSquare, FaChevronDown, FaChevronRight, FaMinusSquare, FaSquare } from 'react-icons/fa';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { ReportChatSessionRequest } from '../../Model/Request/ClientAgent/ReportChatSessionRequest';
import { ReportChatSession } from '../../Controller/Api/ClientAgentController';

interface ReportChatProps {
    handleCloseModal: () => void; // Modal'ı kapatmak için fonksiyon prop
}

const ReportChat: React.FC<ReportChatProps> = ({ handleCloseModal }) => {

    const showStatusMessage = useShowStatusMessage();


    const [treeData, setTreeData] = useState<Node[]>([]);
    const [treeOptions, setTreeOptions] = useState<{ value: string; label: string }[]>([]);
    const [selectedTreeValue, setSelectedTreeValue] = useState<string>('');
    const [selectedStructureValue, setselectedStructureValue] = useState<string>('');
    const [expandedItems, setExpandedItems] = useState<string[]>([]);
    const [selectedReturnOption, setSelectedReturnOption] = useState<string>('');
    const [cityOptions, setCityOptions] = useState<{ value: string; label: string }[]>([]);
    const [selectedCity, setSelectedCity] = useState<string>('');
    const [structureOptions, setStructureOptions] = useState<{ value: string; label: string }[]>([]);
    const [isStructureRequired, setIsStructureRequired] = useState<boolean>(false);
    const [senderRequest, setSenderRequest] = useState<string>('');
    const [actionOnRequest, setActionOnRequest] = useState<string>('');

    const refSenderName = useRef<TextBoxHandle>(null);
    const refSenderPhone = useRef<TextBoxHandle>(null);
    const refSenderRequest = useRef<TextBoxHandle>(null);
    const refActionOnRequest = useRef<TextBoxHandle>(null);
    const refTreeCombo = useRef<any>(null);
    const refCityCombo = useRef<any>(null);
    const refReturnOptionCombo = useRef<any>(null);

    const { currentSession, setMessages, removeSessionById } = useChat(); // useChat'ten setMessages ve setActiveSessions alınıyor
    const [senderName, setSenderName] = useState<string>(currentSession?.sessionOwnerName || ''); // currentSession'dan al
    const [senderPhone, setSenderPhone] = useState<string>(currentSession?.sessionOwnerTel || ''); // currentSession'dan al


    const [isInformed, setIsInformed] = useState<boolean>(false);
    const [checkedItem, setCheckedItem] = useState<string | null>(null); // Tek bir seçili node

    const [searchTerm, setSearchTerm] = useState<string>(''); // Arama terimi için state
    useEffect(() => {
        const fetchTreeData = async () => {
            const response: ApiBaseResponse<GetClientsTreeViewResponse> | null = await GetClientsTreeView(GlobalOperations.ClientId);

            if (!response || response.content == null || response.responseCode !== ResponseCode.OK) {
                return;
            }

            // TreeViewList'i Node[] formatına dönüştür
            const treeViewList = response.content.treeViewList;
            const treeNodes = transformToTreeNodes(treeViewList);
            setTreeData(treeNodes);
        };
        fetchTreeData();
    }, [GlobalOperations.ClientId]);

    // TreeViewList'ten Node yapısına dönüştürücü
    const transformToTreeNodes = (data: TreeViewList[]): Node[] => {
        const map = new Map<number, Node>();

        // TreeViewList verisindeki her bir node'u oluşturuyoruz
        data.forEach(node => {
            map.set(node.id, {
                value: node.id.toString(),
                label: node.text,
                children: [],
            });
        });

        const tree: Node[] = [];

        // Her bir node'un parent'ına göre yerleştiriyoruz
        data.forEach(node => {
            if (node.parent === -1) {
                // Parent'ı olmayan (root) düğüm
                tree.push(map.get(node.id)!);
            } else {
                // Parent'ı olan node'ları çocuk olarak ekliyoruz
                const parentNode = map.get(node.parent);
                if (parentNode) {
                    parentNode.children?.push(map.get(node.id)!);
                }
            }
        });

        return tree;
    };

    const handleReturnOptionChange = (value: string | string[]) => {
        setSelectedReturnOption(value as string);
    };
    useEffect(() => {
        const loadCities = () => {
            const citiesResponse: GetAllCitiesByCountryResponse = citiesData;
            const options = citiesResponse.cities.map((city: CityDetail) => ({
                value: city.id.toString(),
                label: city.cityName,
            })).sort((a, b) => a.label.localeCompare(b.label));
            setCityOptions(options);
        };

        loadCities();
    }, []);

    // react-checkbox-tree'nin beklediği Node tipi
    interface Node {
        value: string;
        label: string;
        children?: Node[];
    }

    // Bir node seçildiğinde, otomatik olarak diğer seçilen node'u kaldırır ve sadece bir node seçilir
    const handleTreeChange = (checked: string[]) => {
        setCheckedItem(null);
        // Her zaman sadece bir node seçilir, bu yüzden checked[0]'ı kullanıyoruz
        setCheckedItem(checked.length > 0 ? checked[0] : null);
    };


    const transformTreeData = (data: TreeViewList[]): { value: string; label: string }[] => {
        const map = new Map<number, string>();

        const buildLabel = (id: number, label: string): string => {
            const parentNode = data.find((node) => node.id === id)?.parent;
            if (parentNode !== -1) {
                const parentText = data.find((node) => node.id === parentNode)?.text || '';
                return buildLabel(Number(parentNode), `${parentText} --> ${label}`);
            }
            return label;
        };

        data.forEach((node) => {
            if (node.parent === -1) {
                map.set(node.id, node.text);
            } else {
                const label = buildLabel(node.id, node.text);
                map.set(node.id, label);
            }
        });

        return Array.from(map.entries()).map(([value, label]) => ({
            value: value.toString(),
            label,
        }));
    };


    const handleStructureChange = (value: string | string[]) => {
        setselectedStructureValue(value as string);
    };

    // Ağaç yapısını filtreleme - Artık hem üst hem alt düğümleri arayacak
    const filteredTreeData = (nodes: Node[]): Node[] => {
        if (!searchTerm) return nodes;


        let normalizedSearchTerm: string = normalizeTurkishChars(searchTerm.toLowerCase()).trim();

        const filterNodes = (node: Node): boolean => {
            // Node'un label'ını normalize edip arama terimiyle karşılaştır
            let normalizedLabel: string = normalizeTurkishChars(node.label.toLowerCase()).trim();

            if (normalizedLabel.includes(normalizedSearchTerm)) {
                return true;
            }
            if (node.children && node.children.length > 0) {
                return node.children.some(filterNodes);
            }
            return false;
        };

        return nodes
            .filter(filterNodes)
            .map(node => ({
                ...node,
                children: filteredTreeData(node.children || []),
            }));
    };

    const normalizeTurkishChars = (str: string): string => {
        return str
            .replace(/Ğ/g, 'g')
            .replace(/ğ/g, 'g')
            .replace(/Ü/g, 'u')
            .replace(/ü/g, 'u')
            .replace(/Ş/g, 's')
            .replace(/ş/g, 's')
            .replace(/İ/g, 'i')
            .replace(/I/g, 'i')
            .replace(/ı/g, 'i')
            .replace(/Ç/g, 'c')
            .replace(/ç/g, 'c')
            .replace(/Ö/g, 'o')
            .replace(/ö/g, 'o');
    };

    const handleCityChange = async (value: string | string[]) => {
        setSelectedCity(value as string);

        const cityId = value as string;

        const response: ApiBaseResponse<GetClientsStructureByCityIdResponse> | null =
            await GetClientsStructureByCityId(Number(cityId), 1);

        if (!response || response.content == null || response.responseCode !== ResponseCode.OK) {
            return;
        }

        if (response.content.serviceStructureDetailList.length > 0) {
            const options = response.content.serviceStructureDetailList.map((item: ServiceStructureDetailList) => ({
                value: item.structureId.toString(),
                label: item.structureName,
            }));
            setStructureOptions(options);
            setIsStructureRequired(true);
        } else {
            setStructureOptions([]);
            setIsStructureRequired(false);
        }
    };

    const handleSave = async () => {
        const isSenderNameValid = refSenderName.current?.validate() ?? false;
        const isSenderRequestValid = refSenderRequest.current?.validate() ?? false;

        // Eğer bilgilendirme yapıldıysa (checkbox işaretliyse), işlem alanı da zorunlu
        const isActionOnRequestValid = isInformed ? (refActionOnRequest.current?.validate() ?? false) : true;
 
        const isReturnOptionValid = refReturnOptionCombo.current?.getValue() !== '0';
        const isCityValid = refCityCombo.current?.validate() ?? false;

        if (!isSenderNameValid || !isSenderRequestValid || !isActionOnRequestValid ||   !isReturnOptionValid || !isCityValid) {
            return;
        }

        // Ağaç yapısında kategori seçilmediyse uyarı ver
        if (!checkedItem) {
            showStatusMessage({
                header: 'Eksik Veri Girişi',
                text: 'Kategori Seçiniz',
                status: StatusEnum.ERROR,
                direction: 'down',
                duration: 5000,
                displayType: DisplayType.TOP,
            });
            return;
        }

        let requestData: ReportChatSessionRequest = {
            activeChatSessionId: GlobalOperations.ActiveSessionId,
            clientRequest: senderRequest,
            actionOnRequest: actionOnRequest,
            clientUserName: senderName,
            clientTel: senderPhone,
            clientMail: "",
            cityId: parseInt(selectedCity, 10),
            structureId: parseInt(selectedStructureValue, 10),

            isInformed: isInformed,

            detailData1: null,
            detailData2: null,
            detailData3: null,
            detailData4: null,
            detailData5: null,
            detailData6: null,
            detailData7: null,
            detailData8: null,
            detailData9: null,
            detailData10: null,

            categoryTreeIdList: checkedItem ? [parseInt(checkedItem)] : [],
        };

        // API isteği
        let responseData: ApiBaseResponse<null> | null =
            await ReportChatSession(requestData);

        if (!responseData || responseData.responseCode !== ResponseCode.OK) {
            showStatusMessage({
                header: responseData?.textHeader ?? 'Hata',
                text: responseData?.text ?? 'Hata',
                status: StatusEnum.ERROR,
                direction: 'down',
                duration: 5000,
                displayType: DisplayType.TOP,
            });
            return;
        }

        // Başarılı ise
        showStatusMessage({
            header: responseData?.textHeader ?? 'Başarı',
            text: responseData?.text ?? 'İşlem başarılı',
            status: StatusEnum.SUCCESS,
            direction: 'down',
            duration: 5000,
            displayType: DisplayType.TOP,
        });

        // 1. Popup'ı kapat
        handleCloseModal();

        // 2. Mesajları temizle ve bir konuşma seçin yazısını göster
        setMessages([]); // Mesajları temizle

        // 3. Sidebar'dan oturumu kaldır
        // removeSessionById(GlobalOperations.ActiveSessionId);

        let reuqest: EndSessionByAgentRequest = {
            sessionId: GlobalOperations.ActiveSessionId,
            auth: GlobalOperations.UserToken
        }

        if (GlobalOperations.SignalRConnection == null) {
            console.error("SignalR bağlantısı yok.");
            return;
        }
        let response: boolean = await GlobalOperations.SignalRConnection.invoke("endSessionByAgent", reuqest);



        // Aktif oturumu sıfırla
        GlobalOperations.ActiveSessionId = 0;


    };



    return (
        <div>

            <Row>
                <Col md={6}>
                    <TextBox
                        label="Görüşme Yapılan Kişinin Adı ve Soyadı"
                        inputId="input-name"
                        required
                        errorMessage="Bu Alan Boş Olamaz"
                        ref={refSenderName}
                        type={InputType.TEXT}
                        value={senderName}
                        onChange={(e) => setSenderName(e.target.value)}
                    />
                </Col>
                <Col md={6}>
                    <TextBox
                        label="Görüşme Yapılan Kişinin Telefonu"
                        inputId="input-phone"
                        required={false}
                        errorMessage="Bu Alan Boş Olamaz"
                        ref={refSenderPhone}
                        type={InputType.TEXT}
                        value={senderPhone}
                        onChange={(e) => setSenderPhone(e.target.value)}
                        maxLength={12}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <TextArea
                        label="Görüşme Yapılan Kişinin İlettiği Talep"
                        inputId="input-request"
                        required
                        errorMessage="Bu Alan Boş Olamaz"
                        ref={refSenderRequest}
                        value={senderRequest}
                        onChange={setSenderRequest}
                    />
                </Col>
                <Col md={6}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="checkbox-is-informed"
                        checked={isInformed}
                        onChange={(e) => setIsInformed(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="checkbox-is-informed">
                        Başvuru Sahibine Bilgilendirme Yapıldı
                    </label>
                    {isInformed && (
                        <Col md={12}>
                            <TextArea
                                label="Talebe Yapılan İşlem"
                                inputId="input-response"
                                required
                                errorMessage="Bu Alan Boş Olamaz"
                                ref={refActionOnRequest}
                                value={actionOnRequest}
                                onChange={setActionOnRequest}
                            />
                        </Col>
                    )}
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    {/* Arama Kutusu */}
                    <TextBox

                        placeholder="Kategori ara..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        label="Ağaç Yapısı"
                        inputId="textbox-searc"
                    />

                    <CheckboxTree
                        nodes={filteredTreeData(treeData)}  // Filtrelenmiş ağaç verisi
                        checked={checkedItem ? [checkedItem] : []}  // Tek bir node seçilebilir
                        expanded={expandedItems}  // Genişletilmiş düğümler
                        onCheck={handleTreeChange}  // Seçim değişikliği
                        onExpand={expanded => setExpandedItems(expanded)}  // Genişletme değişikliği
                        icons={{
                            check: <FaCheckSquare />,
                            uncheck: <FaSquare />,
                            halfCheck: <FaMinusSquare />,
                            expandClose: <FaChevronRight />,
                            expandOpen: <FaChevronDown />,
                        }}
                    />
                </Col>
                <Col md={6}>
                    <ComboBox
                        label="Çağrı Yapısı"
                        inputId="input-call-structure"
                        required={isStructureRequired}
                        errorMessage="Bu Alan Boş Olamaz"
                        ref={refCityCombo}
                        options={structureOptions}
                        value={selectedStructureValue}
                        onChange={handleStructureChange}
                        mode={ComboBoxMode.Standard}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <ComboBox
                        label="İl"
                        inputId="input-city"
                        required
                        errorMessage="Bu Alan Boş Olamaz"
                        ref={refCityCombo}
                        options={cityOptions}
                        value={selectedCity}
                        onChange={handleCityChange}
                        mode={ComboBoxMode.SearchableOneSelect}
                    />
                </Col>
                <Col md={6}>
                    <ComboBox
                        label="Arayan Geri Dönüş Bekliyor Mu?"
                        inputId="input-return-option"
                        required
                        errorMessage="Bu Alan Boş Olamaz"
                        ref={refReturnOptionCombo}
                        options={[
                            { value: '0', label: 'Seçiniz' },
                            { value: '1', label: 'Arayan Geri Dönüş Beklemiyor - Geri Dönüş YOK' },
                            { value: '2', label: 'Arayan Geri Dönüş Bekliyor' },
                        ]}
                        value={selectedReturnOption}
                        onChange={handleReturnOptionChange}
                        mode={ComboBoxMode.Standard}
                    />
                </Col>
            </Row>

            <div className="d-flex justify-content-end mt-4">
                <LoadingButton
                    label="Kaydet"
                    onClick={(event) => handleSave()}
                    className="btn btn-primary me-2"
                />

            </div>
            {/* Mesaj Listesi - currentSession.messageList'ten alınıyor */}
            <div className="message-history mt-4">
                <h4>Görüşme Geçmişi</h4>
                {currentSession?.messageList.map((message, index) => {
                    const isAgent = message.side === MesajiGonderenTarafEnum.AlbinaSoft;
                    const bubbleStyle = {
                        marginBottom: '10px',
                        padding: '10px',
                        borderRadius: isAgent ? '1.125rem 1.125rem 0 1.125rem' : '1.125rem 1.125rem 1.125rem 0',
                        backgroundColor: isAgent ? '#2980b9' : '#333',
                        color: '#fff',
                        maxWidth: '60%',
                        alignSelf: isAgent ? 'flex-end' : 'flex-start',
                        textAlign: isAgent ? 'right' : 'left',
                        marginLeft: isAgent ? 'auto' : '0',
                        marginRight: isAgent ? '0' : 'auto',
                    } as React.CSSProperties;

                    return (
                        <div key={index} className="message" style={bubbleStyle}>
                            <div
                                style={{ marginBottom: '5px', whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: message.messageContent }}
                            />
                            <div style={{ fontSize: '12px', color: '#ccc', marginTop: '5px' }}>
                                <strong>{message.messageFrom}</strong>
                                <span> {new Date(message.messageDate).toLocaleString()}</span>
                            </div>
                        </div>
                    );
                })}
            </div>

        </div>
    );
};

export default ReportChat;
